import Box from "@mui/material/Box";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { getOrgType } from "./../../../../utils/Token";

function BackBtn({ handleBackClick, listTitle, clientName, showPinned }) {
  function navigateToPreviousComponent() {
    if (showPinned) {
      handleBackClick("child");
    } else {
      handleBackClick("parent");
    }
  }

  return (
    <>
      <Box
        px={3}
        py={2}
        className="d-flex align-items-center text-center border-bottom cursor-pointer"
        style={{ flex: "0 0 auto" }}
      >
        <ArrowBackIosNewRoundedIcon
          fontSize="1rem"
          className="txt-clr-blue4"
          onClick={navigateToPreviousComponent}
        />

        <div className="text-start">
          <div className="ms-3 fw-semibold txt-clr-blue3">{listTitle}</div>
          <small className="ms-3 d-block text-muted">
            {/* {!showPinned &&  getOrgType() === "Admin" && clientName} */}
            {!showPinned && clientName}
          </small>
        </div>
      </Box>
    </>
  );
}

export default BackBtn;
